// 引入路由文件这种的公共路由
import { constantRoutes } from '../router';
// Layout 组件是项目中的主页面，切换路由时，仅切换Layout中的组件
export function getAsyncRoutes(routes) {
    const res = [
        {
            path: '/',
            component: () => import('@/components/common/Home.vue'),
            meta: { title: '云上中医' },
            children: []
        },
        {
            path: "*",
            redirect: "/404"
        }
    ]
    // 遍历路由数组去重组可用的路由
    routes.forEach(item => {
        const newItem = {
            path: '',
            meta: {title: ''}
        };
        newItem.component = () => import(`@/components/page/${item.urlAddress}.vue`)
        newItem.path = `/${item.urlAddress}`
        // newItem.name = item.menuCaption
        newItem.meta.title = item.menuCaption
        // 若遍历的当前路由存在子路由，需要对子路由进行递归遍历
        if (item.children.length > 0) {
            item.children.forEach(item => {
                const newItem = {
                    path: '',
                    meta: {title: ''}
                };
                newItem.component = () => import(`@/components/page/${item.urlAddress}.vue`)
                newItem.path = `/${item.urlAddress}`
                // newItem.name = item.menuCaption
                newItem.meta.title = item.menuCaption
                res[0].children.push(newItem)
            })
        }
        res[0].children.push(newItem)
    })
    // 返回处理好且可用的路由数组
    return res
}